import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const WorkSection = () => {
	return (
		<StyledSection
			data-aos="fade-up"
			data-aos-offset="200"
			data-aos-delay="50"
			data-aos-duration="1200"
			data-aos-easing="ease-in"
			data-aos-once="true"
		>
			<Work id="works">
				<div className="title-work">
					<h2>Works</h2>
				</div>
				<img
					src="./images/Sphere-Blue-Glossy.png"
					alt=""
					className="blue-ball obj"
				/>
				<img
					src="./images/SuperToroid.png"
					alt=""
					className="toroid obj"
				/>
				<img
					src="./images/RoundCube.png"
					alt=""
					className="roundcube obj"
				/>
			</Work>

			<ImageGridDesk>
				<div className="left">
					<div className="works-card">
						<img
							src="./images/coffee.png"
							alt=""
							className="coffee"
						/>
						<span className="works-card-name">Branding</span>
						<Link to="/branding" className="works-card-link">
							view &gt;
						</Link>
					</div>

					<div className="works-card">
						<img
							src="./images/play-stop.png"
							alt=""
							className="play"
						/>
						<span className="works-card-name">
							Interactive & <br /> Motion Design
						</span>
						<Link to="/motion" className="works-card-link">
							view &gt;
						</Link>
					</div>
				</div>

				<div className="right">
					<img src="./images/logos.png" alt="" className="logos" />

					<div className="works-card">
						<img
							src="./images/phone.png"
							alt=""
							className="phone"
						/>
						<span className="works-card-name">Product Design</span>
						<Link to="/product" className="works-card-link">
							view &gt;
						</Link>
					</div>
					<div className="works-card ">
						<img src="./images/kobe.png" alt="" className="kobe" />
						<span className="works-kobe">Illustrations</span>
						<a
							href="https://www.behance.net/gallery/107530357/Illustrations"
							className="works-card-link"
						>
							view &gt;
						</a>
					</div>
				</div>
			</ImageGridDesk>

			<ImageGridMobile>
				<div className="works-card">
					<Link to="/branding">
						<img
							src="./images/coffee.png"
							alt=""
							className="coffee"
						/>
					</Link>

					<span className="works-card-name">Branding</span>
					<Link to="/branding" className="works-card-link">
						view &gt;
					</Link>
				</div>

				<div className="works-card">
					<Link to="/motion">
						<img
							src="./images/play-stop.png"
							alt=""
							className="play"
						/>
					</Link>

					<span className="works-card-name">
						Interactive & <br /> Motion Design
					</span>
					<Link to="/motion" className="works-card-link">
						view &gt;
					</Link>
				</div>

				<img src="./images/logos.png" alt="" className="logos" />

				<div className="works-card">
					<Link to="/product">
						<img
							src="./images/phone.png"
							alt=""
							className="phone"
						/>
					</Link>

					<span className="works-card-name">Product Design</span>
					<Link to="/product" className="works-card-link">
						view &gt;
					</Link>
				</div>
				<div className="works-card ">
					<a href="https://www.behance.net/gallery/107530357/Illustrations">
						<img src="./images/kobe.png" alt="" className="kobe" />
					</a>

					<span className="works-kobe">Illustrations</span>
					<a
						href="https://www.behance.net/gallery/107530357/Illustrations"
						className="works-card-link"
					>
						view &gt;
					</a>
				</div>
			</ImageGridMobile>
		</StyledSection>
	);
};

export default WorkSection;

const StyledSection = styled.section`
	padding: 80px 16px;
	padding-bottom: 32px;
`;

const Work = styled.div`
	margin: 48px auto;
	position: relative;
	width: max-content;
	margin: 0 auto;

	.obj {
		width: 100px;
		position: absolute;
	}

	.blue-ball {
		width: 80px;
		top: -30px;
		left: -72px;
		z-index: -1;

		@keyframes bounce {
			0% {
				transform: translateY(0);
			}

			100% {
				transform: translateY(-7px);
			}
		}
		& {
			animation: bounce 1.3s infinite alternate;
		}
	}

	.toroid {
		top: -60px;
		left: 50%;
		z-index: -1;

		@keyframes bounce {
			0% {
				transform: translateY(0);
			}

			100% {
				transform: translateY(10px);
			}
		}
		& {
			animation: bounce 1.5s infinite alternate;
		}
	}
	.roundcube {
		bottom: -50px;
		right: -80px;
		z-index: -1;

		@keyframes bounce {
			0% {
				transform: translateY(0);
			}

			100% {
				transform: translateY(-8px);
			}
		}
		& {
			animation: bounce 1s infinite alternate;
		}
	}
`;

const ImageGridMobile = styled.div`
	display: flex;
	flex-direction: column;
	gap: 32px;
	padding-top: 72px;
	img {
		width: 300px;
		margin: 0 auto;
		border-radius: 8px;
	}

	.works-kobe {
		position: absolute;
		top: 8px;
		left: 32px;
		font-size: 1rem;
		color: white;
		font-family: AxiformaBold;

		@media (min-width: 390px) {
			top: 16px;
			left: 60px;
		}
		@media (min-width: 550px) {
			top: 16px;
			left: 128px;
		}
	}

	.works-card {
		position: relative;

		.works-card-name {
			position: absolute;
			top: 40px;
			left: 40px;
			font-size: 1.5rem;
			color: white;
			line-height: 1.1;
			font-weight: 500;
			font-family: AxiformaBold;
		}

		.works-card-link {
			color: white;
			position: absolute;
			bottom: 40px;
			left: 40px;
			text-decoration: none;
			font-family: AxiformaLight;
			text-transform: capitalize;
		}

		@media (min-width: 390px) {
			.works-card-name {
				top: 32px;
				left: 60px;
				font-family: AxiformaBold;
			}

			.works-card-link {
				bottom: 32px;
				left: 60px;
			}
		}

		@media (min-width: 550px) {
			.works-card-name {
				top: 32px;
				left: 128px;
				font-family: AxiformaBold;
			}

			.works-card-link {
				bottom: 32px;
				left: 128px;
			}
		}
	}

	@media (min-width: 750px) {
		display: none;
	}
`;
const ImageGridDesk = styled.div`
	display: none;

	@media (min-width: 750px) {
		display: grid;
		grid-template-columns: 1fr 1fr;

		max-width: 600px;
		margin: 72px auto;
		gap: 16px;

		.left {
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			gap: 32px;

			img {
				border-radius: 8px;
			}
		}

		.right {
			display: flex;
			flex-direction: column;

			gap: 32px;
			justify-content: space-between;

			img {
				border-radius: 8px;
			}
		}

		.works-kobe {
			position: absolute;
			top: 8px;
			left: 16px;
			font-size: 1.5rem;
			color: white;
			font-family: AxiformaBold;
		}

		.works-card {
			position: relative;

			.works-card-name {
				position: absolute;
				top: 16px;
				left: 16px;
				font-size: 1.5rem;
				color: white;
				line-height: 1.1;
				font-weight: 500;
				font-family: AxiformaBold;
			}

			.works-card-link {
				color: white;
				position: absolute;
				bottom: 16px;
				left: 16px;
				text-decoration: none;
				font-family: AxiformaLight;
				text-transform: capitalize;
			}
		}
	}

	@media (min-width: 1000px) {
		max-width: 950px;
		gap: 32px;
		.works-kobe {
			position: absolute;
			top: 16px;
			left: 32px;
			font-size: 1.5rem;
			color: white;
		}

		.works-card {
			.works-card-name {
				position: absolute;
				top: 36px;
				left: 36px;
				font-size: 2rem;
				color: white;
				line-height: 1.1;
				font-weight: 500;
			}

			.works-card-link {
				color: white;
				position: absolute;
				bottom: 36px;
				left: 36px;
			}
		}
	}
`;
